import React from 'react'

import clsx from 'clsx'

import { Icon } from 'src/components/ui'
import { ParticipantUser } from 'src/pages/Bottle/Bottles.types'
import { formattedText } from 'src/utils/formattedText'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import { abbreviationOfName } from '../../utils/abbreviationOfName'

interface Props {
  participantsList: ParticipantUser[] | undefined
  total_stars: number
  total_tickets: number
  variant: 'list' | 'bottle' | undefined
  typeOfBottle: 'ANY' | 'FIXED' | 'CHARITABLE' | 'LOTTERY' | undefined
  targetElementRef: React.RefObject<HTMLDivElement>
  styles?: any
}

export const ParticipantsList: React.FC<Props> = ({
  participantsList,
  typeOfBottle,
  variant,
  total_stars,
  total_tickets,
  targetElementRef,
  styles,
}) => {
  const myName = useGlobalStore((store) => store.user?.username)

  participantsList = participantsList?.sort((a, b) => {
    const aTotalTickets = a.stars_amount * 20 + a.tickets
    const bTotalTickets = b.stars_amount * 20 + b.tickets

    return bTotalTickets - aTotalTickets
  })

  return (
    <>
      {participantsList?.map((participant, index) => {
        const { user, stars_amount, tickets } = participant

        localStorage.setItem('numberStarsToTickets', String(stars_amount))
        const totalTickets = stars_amount * 20 + tickets

        if (user.username === null) {
          user.username = user.first_name + ' ' + user.last_name
        }
        const myEl = user.username === myName
        let interest

        const totalSumTicketsAndStars = total_tickets + total_stars * 20

        if (typeOfBottle !== 'FIXED') {
          interest = ((totalTickets / totalSumTicketsAndStars) * 100).toFixed(1)
        }

        const itemClass = clsx(
          styles['participants_list-item'],
          myEl && styles.my,
          variant === 'list' && myEl && styles.arbitrary,
          !interest && myEl && variant === 'list' && styles.fixed,
        )

        const ref = myEl ? targetElementRef : null

        return (
          <div className={itemClass} key={user.id} ref={ref}>
            <p className={styles.number}>{formattedText(++index)}</p>
            <p className={styles.name}>{user.username === myName ? 'YOU' : abbreviationOfName(user.username)}</p>

            <div className={styles.amount}>
              <p>{formattedText(Math.abs(totalTickets))}</p>
              <Icon name={myEl && variant === 'list' ? 'ticket_white' : 'ticket'} />
              {interest && <p className={styles.interest}>{interest}%</p>}
            </div>
          </div>
        )
      })}
    </>
  )
}
